import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBorderBtn from "../../components/atoms/button/mainBorderBtn";

import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import { fileUrl } from "../../api/api";
import {
  formatNumberWithCommas,
  formatPhoneNumber,
} from "../../util/formatNumber";
import MemberApi from "../../api/member.api";
import { errorHandler } from "../../util/errorHandler";

import PaymentApi from "../../api/payment.api";
import Loading from "../../components/templates/loading";
import { getPaymentInfo } from "../../util/paymentInfoStorage";

const LecturePaymentComplete = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const callbackKey =
    searchParams.get("paymentKey") || searchParams.get("customerKey");
  const [paymentProcessed, setPaymentProcessed] = useState(
    Boolean(
      callbackKey && sessionStorage.getItem("paymentProcessed") === callbackKey,
    ),
  );
  const paymentProcessingRef = useRef(false);

  const { lectureInfo, localData } = getPaymentInfo(location.state);
  const paymentTitle = localData?.consultingMerchId
    ? "컨설팅 구매"
    : lectureInfo?.image
      ? "구독 결제"
      : "강의 구매";
  const categoryType =
    lectureInfo?.lectureCategory?.lectureCategoryType ??
    lectureInfo?.lectureCategoryType;
  const isConsulting = Boolean(localData?.consultingMerchId);
  const isSubscription = Boolean(
    lectureInfo?.image &&
    !localData?.lectureVideoId &&
    !localData?.consultingMerchId,
  );
  const isValidPaymentSource = Boolean(
    (location.state || callbackKey) && lectureInfo && localData,
  );
  const [myInfo, setMyInfo] = useState({});
  const [myInfoLoading, setMyInfoLoading] = useState(
    Boolean(callbackKey && !paymentProcessed),
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      navigate(route.login, { replace: true });
      return;
    }

    if (!isValidPaymentSource) {
      navigate(route.my_page_payment_history, { replace: true });
      return;
    }

    myInfoData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const myInfoData = async () => {
    try {
      const myInfoRP = (await MemberApi.getMyInfo()).data.data.content;
      sessionStorage.setItem("membership", myInfoRP.membership);
      setMyInfo(myInfoRP);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (
      isValidPaymentSource &&
      callbackKey &&
      !paymentProcessed &&
      !paymentProcessingRef.current
    ) {
      paymentProcessingRef.current = true;
      onPaymentFunc();
    }
  }, [callbackKey, paymentProcessed]);

  async function onPaymentFunc() {
    try {
      setMyInfoLoading(true);
      if (searchParams.get("paymentKey")) {
        if (!localData?.orderNumber) {
          throw new Error("결제 요청 정보를 찾을 수 없습니다.");
        }
        if (searchParams.get("orderId") !== localData.orderNumber) {
          throw new Error("결제 주문 정보가 일치하지 않습니다.");
        }
        const callbackAmount = Number(searchParams.get("amount"));
        if (
          !searchParams.has("amount") ||
          !Number.isFinite(callbackAmount) ||
          callbackAmount !== Number(localData.realPay)
        ) {
          throw new Error("결제 금액이 일치하지 않습니다.");
        }

        await PaymentApi.payment({
          ...localData,
          pgPaymentId: searchParams.get("paymentKey"),
        });
      } else {
        if (!searchParams.get("authKey") || !searchParams.get("customerKey")) {
          throw new Error("구독 결제 인증 정보가 없습니다.");
        }

        const billData = {
          authKey: searchParams.get("authKey"),
          price: localData.realPay,
          customerKey: searchParams.get("customerKey"),
        };

        await PaymentApi.membershipPayment(billData);

        sessionStorage.setItem("membership", "true");
      }
      setPaymentProcessed(true);
      sessionStorage.setItem("paymentProcessed", callbackKey);
    } catch (error) {
      navigate(route.lecture_payment_fail, {
        replace: true,
        state: { lectureInfo, localData, paymentError: true },
      });
    } finally {
      setMyInfoLoading(false);
    }
  }

  if (!isValidPaymentSource) return <Loading />;

  return (
    <>
      <LecturePaymentCompleteSection>
        {myInfoLoading ? (
          <div
            style={{
              width: "100%",
              height: "60vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading />
          </div>
        ) : (
          <PCContainer
            style={{
              flexDirection: "column",
              padding: isSmall ? "20px 20px 80px 20px" : "80px 0px 150px 0px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: isMobile ? 40 : 141,
              }}
            >
              <img
                style={{
                  width: isMobile ? 335 : 380,
                  height: isMobile ? 190 : 240,
                  marginBottom: isMobile ? 0 : 20,
                }}
                src="/assets/images/pay_complete.png"
                alt="pay_complete"
              />
              <LSBdDisplay02
                style={{
                  color: "#000000",
                  fontSize: isMobile ? 18 : 24,
                  lineHeight: isMobile ? "25.2px" : "33.6px",
                }}
              >
                {paymentTitle}가 완료되었습니다!
              </LSBdDisplay02>
            </div>

            <LSBdH2HeadLine
              style={{
                color: "#5050FF",
                fontSize: isMobile ? 15 : 18,
                lineHeight: isMobile ? "21px" : "25.2px",
              }}
            >
              구매 정보
            </LSBdH2HeadLine>

            <div
              style={{
                marginTop: 16,
                marginBottom: isMobile ? 16 : 30,
                width: "100%",
                height: 1,
                background: "#DBDDE0",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "flex-start" : "center",
              }}
            >
              <img
                src={
                  lectureInfo?.thumbnailServerFileName
                    ? `${fileUrl}/${lectureInfo?.thumbnailServerFileName}`
                    : lectureInfo?.image
                      ? lectureInfo?.image
                      : ""
                }
                style={{
                  width: isMobile ? "100%" : 175,
                  height: isMobile ? 214 : 112,
                  marginRight: isMobile ? 0 : 40,
                  borderRadius: isMobile ? 10 : 8,
                  marginBottom: isMobile ? 20 : 0,
                }}
                alt="video"
              />
              <LSBdDisplay01
                style={{
                  flex: 1,
                  color: "#000000",
                  marginRight: isMobile ? 0 : 90,
                  fontSize: isMobile ? 16 : 20,
                  lineHeight: isMobile ? "22.4px" : "28px",
                  marginBottom: isMobile ? 10 : 0,
                }}
              >
                {lectureInfo?.title}
              </LSBdDisplay01>

              <div
                style={{
                  minWidth: isMobile ? "100%" : 260,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <TopTextContain $isMobile={isMobile}>
                  <TopRightText $isMobile={isMobile}>결제번호</TopRightText>
                  <TopLeftText $isMobile={isMobile}>
                    {searchParams.get("paymentKey")
                      ? searchParams.get("paymentKey")
                      : searchParams.get("customerKey")
                        ? searchParams.get("customerKey")
                        : localData?.pgPaymentId}
                  </TopLeftText>
                </TopTextContain>
                <TopTextContain $isMobile={isMobile}>
                  <TopRightText $isMobile={isMobile}>결제일자</TopRightText>
                  <TopLeftText $isMobile={isMobile}>
                    {localData?.date}
                  </TopLeftText>
                </TopTextContain>
                <TopTextContain $isMobile={isMobile}>
                  <TopRightText $isMobile={isMobile}>결제금액</TopRightText>
                  <TopLeftText $isMobile={isMobile}>
                    {formatNumberWithCommas(localData?.realPay)}원
                  </TopLeftText>
                </TopTextContain>
                <TopTextContain $isMobile={isMobile}>
                  <TopRightText $isMobile={isMobile}>결제수단</TopRightText>
                  <TopLeftText $isMobile={isMobile}>
                    {localData?.payMethod}
                  </TopLeftText>
                </TopTextContain>
                <TopTextContain $isMobile={isMobile}>
                  <TopRightText $isMobile={isMobile}>결제상태</TopRightText>
                  <TopLeftText $isMobile={isMobile}>결제완료</TopLeftText>
                </TopTextContain>
              </div>
            </div>

            <LSBdH2HeadLine
              style={{
                color: "#5050FF",
                marginTop: isMobile ? 44 : 60,
                fontSize: isMobile ? 15 : 18,
                lineHeight: isMobile ? "21px" : "25.2px",
              }}
            >
              구매자 정보
            </LSBdH2HeadLine>

            <div
              style={{
                marginTop: 16,
                marginBottom: isMobile ? 16 : 30,
                width: "100%",
                height: 1,
                background: "#DBDDE0",
              }}
            />

            <TopTextContain $isMobile={isMobile}>
              <TopRightText $isMobile={isMobile}>구매자</TopRightText>
              <TopLeftText $isMobile={isMobile}>{myInfo?.name}</TopLeftText>
            </TopTextContain>
            <TopTextContain $isMobile={isMobile}>
              <TopRightText $isMobile={isMobile}>전화번호</TopRightText>
              <TopLeftText $isMobile={isMobile}>
                {formatPhoneNumber(myInfo?.phoneNumber)}
              </TopLeftText>
            </TopTextContain>
            <TopTextContain $isMobile={isMobile}>
              <TopRightText $isMobile={isMobile}>이메일</TopRightText>
              <TopLeftText $isMobile={isMobile}>{myInfo?.email}</TopLeftText>
            </TopTextContain>

            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "center",
                marginTop: isMobile ? 40 : 100,
              }}
            >
              <MainBtn
                onClick={() => {
                  if (isSubscription) {
                    navigate(route.lecture_list);
                  } else if (isConsulting) {
                    navigate(route.consulting_progress);
                  } else {
                    navigate(
                      `${route.my_page_classroom}?category=${categoryType ?? "PAID_LECTURE"}`,
                    );
                  }
                }}
                style={{
                  marginRight: isMobile ? 0 : 30,
                  width: isMobile ? "100%" : 380,
                  marginBottom: isMobile ? 10 : 0,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                  }}
                >
                  {isSubscription
                    ? "강의 둘러보기"
                    : isConsulting
                      ? "필요 서류 제출하기"
                      : "나의 강의실 가기"}
                </LSRgH1HeadLine>
              </MainBtn>

              <MainBorderBtn
                onClick={() => {
                  navigate(route.my_page_payment_history);
                }}
                style={{
                  width: isMobile ? "100%" : 380,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#5050FF",
                    textAlign: "center",
                  }}
                >
                  결제 내역 확인하기
                </LSRgH1HeadLine>
              </MainBorderBtn>
            </div>
          </PCContainer>
        )}
      </LecturePaymentCompleteSection>
    </>
  );
};

export default LecturePaymentComplete;

const LecturePaymentCompleteSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const TopTextContain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => (props.$isMobile ? "6px" : "3px")};
`;

const TopRightText = styled(LSBdBody01)`
  width: ${(props) => (props.$isMobile ? "42px" : "55px")};
  margin-right: ${(props) => (props.$isMobile ? "10px" : "18px")};
  font-size: ${(props) => (props.$isMobile ? "12px" : "14px")};
  line-height: ${(props) => (props.$isMobile ? "14.4px" : "19.6px")};

  color: #898e99;
`;

const TopLeftText = styled(LSRgBody01)`
  font-size: ${(props) => (props.$isMobile ? "12px" : "14px")};
  line-height: ${(props) => (props.$isMobile ? "14.4px" : "19.6px")};

  color: #000000;
`;
